import React from 'react';
import ContentfulCardsBlock from 'components/Contentful/ContentfulCardsBlock';

import { CardBlockContainer } from '../../styles';

const ContentfulCardsBlockColumnWrapper = item => (
  <CardBlockContainer>
    <ContentfulCardsBlock {...item} />
  </CardBlockContainer>
);

export default ContentfulCardsBlockColumnWrapper;
